import { MfcStringUtilities } from './MfcStringUtilities'

export const MfcUserNotepad = {
    generateEntryDate: function () {
        const oDate = new Date()

        const hMonths = [
            '',
            'January',
            'February',
            'March',
            'April',
            'May',
            'June',
            'July',
            'August',
            'September',
            'October',
            'November',
            'December',
        ]

        let sDateString =
            '[ ' + hMonths[oDate.getMonth() + 1] + ' ' + oDate.getDate()

        if (
            oDate.getDate() === 1 ||
            oDate.getDate() === 21 ||
            oDate.getDate() === 31
        )
            sDateString += 'st'
        else if (oDate.getDate() === 2 || oDate.getDate() === 22)
            sDateString += 'nd'
        else if (oDate.getDate() === 3 || oDate.getDate() === 23)
            sDateString += 'rd'
        else sDateString += 'th'

        sDateString +=
            " '" +
            MfcStringUtilities.char_padding(
                String(oDate.getFullYear() - 2000),
                2,
                '0',
            ) +
            ' ]'

        return sDateString
    },
}
